import React, { useEffect, useState } from 'react';
import {Outlet, useNavigate,useMatches} from 'react-router-dom';
import useLoginDetector from '@/hooks/useLoginDetector';
import Layout from '@/components/Layout/index';
import {useAppShallowEqualSelector, useAppDispatch} from '@/hooks/useStores';
import {info} from '@/api/setting';
// import Layout from '@/components/Layout/index3'

// import styles from './index.module.css'

// console.log('==qs',qs.stringify(qs.parse('1')))

function Index () {
  const dispatch = useAppDispatch()
  // const matches = useMatches();
  useLoginDetector()
  useEffect(()=>{
    // console.log('/index.tsx [19]--1',matches);
    // menuPermisson().then(res=>{
    //   dispatch(setPermissionMenu(res.data||[]))
    // }).catch(err=>{

    // })
    // const userInfo = JSON.parse(localStorage.getItem('userInfo')||'{}')
    // if(!userInfo?.userId) {
    //   getUserInfo()
    // }
  },[])

  const getUserInfo = async ()=> {
    const res = await info()
    if(res.ok) {
      localStorage.setItem('userInfo',JSON.stringify(res.data))
    }else {

    }
    console.log('/index.tsx [28]--1','res',res);
  }
  return <Layout>
    <Outlet />
  </Layout>
}

export default React.memo(Index)